module.exports = __webpack_public_path__ + "img/08ba0fe52a521f5d6e0630f89e58184d.png";